"use client";

import { useEffect } from "react";
import { useActivePartner } from "@/contexts/ActivePartnerContext";
import { setAnalyticsActivePartner } from "@/lib/analytics";

export default function ActivePartnerAnalyticsSync(): null {
  const { activePartnerCode } = useActivePartner();
  useEffect(() => {
    setAnalyticsActivePartner(activePartnerCode);
  }, [activePartnerCode]);
  return null;
}
